import { Dispatch, SetStateAction } from 'react';

import { useTeacherStorage } from '~/lib/hooks/useTeacherLocalStorage';
import { StateCollectionsFeature } from '~/lib/states';

import { useCurrentTeacher } from '../hooks/useCurrentTeacher';

export const useGeographicalState = (): [
  string | null,
  Dispatch<SetStateAction<string | null>>,
] => {
  const { data: teacher } = useCurrentTeacher();
  const defaultState = teacher?.state || StateCollectionsFeature.Pennsylvania;

  return useTeacherStorage<string | null>('geographicalState', defaultState);
};
